import React, { useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { HubConnectionBuilder } from "@microsoft/signalr";
import ApiUrls from "../../constants/ApiUrls";
import { downloadContent, saveAsFile } from "../../utils/helpers/file.helpers";
import { Modal, message } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import styles from "../../ui-kit/Modals/BasicModal/BasicModal.module.scss";
import Constants from "../../constants/Common";
import { history } from "../..";
const { confirm } = Modal;

const showConfirm = ({ data, errors, success, fileName, contentType }) => {
  if (!success) {
    const msg = errors?.length ? Constants.statusMessage.errorFile : errors[0];
    message.error(msg);
    return;
  }
  confirm({
    title: "",
    icon: <CheckCircleFilled style={{ color: "#56b4a4" }} />,
    okText: "Да",
    okType: "primary",
    cancelText: "Нет",
    content: <span>Файл готов, скачать?</span>,
    className: styles.basicModal,
    onOk() {
      downloadContent(data, fileName, contentType);
    },
  });
};
const showConfirmProfile = ({ success, text, organizationProfileId }) => {
  if (!success || text) {
    message.error(text || Constants.requestStatuses.error);
    return;
  }
  confirm({
    title: "Загрузка завершена",
    icon: <CheckCircleFilled style={{ color: "#56b4a4" }} />,
    okText: "Да",
    okType: "primary",
    cancelText: "Нет",
    content: <span>Перейти на обновленный профиль?</span>,
    className: styles.basicModal,
    onOk() {
      history.push(`/efficiency/organization-profile/${organizationProfileId}`);
    },
  });
};

const GenerateExcelReport = () => {
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    let connection;
    if (localStorage.getItem("token")) {
      connection = new HubConnectionBuilder()
        .withUrl(`${ApiUrls.webApiUrl}/signalrHubs/reportHub`, {
          withCredentials: false,
          accessTokenFactory: () => localStorage.getItem("token"),
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();

      setConnection(connection);
    }

    return () => {
      // Возвращаем функцию в useEffect, чтобы при отключение компонента
      // отключить WebSocket
      connection.stop();
    };
  }, []);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result) => {
          console.log("Connected!");
          connection.on("ImportProcessingCompleted", (message) => {
            if (message.text.length > 0)
              saveAsFile("ErrorsList.txt", message.text.join("\n"));
            else console.log("Import completed");
          });
          connection.on("BuildingAreaProcessingCompleted", (message) => {
            console.log(message.text);
          });
          connection.on("OrganizationProfileUploaded", (message) => {
            showConfirmProfile(message);
          });
          connection.on("ExportDefectsToExcelCompleted", (message) => {
            showConfirm(message);
          });
          connection.on("ExportMapDefectsToExcelCompleted", (message) => {
            showConfirm(message);
          });
        })
        .catch((e) => {
          setConnection(null);
          console.log("Connection failed: ", e);
        });
    }
  }, [connection]);

  return null;
};

export default GenerateExcelReport;
